export function getErrorCode(error) {
    const isOffline = 
        !navigator.onLine || 
        /network|fetch|networkerror|timeout|net::|ERR_INTERNET_DISCONNECTED/i.test(error.message ?? '') ||
        error?.code === 'ERR_NETWORK'|| 
        error?.response?.status === 0;
      
    return isOffline ? 'NETWORK_ERROR' : 'API_FAILURE';
}